export type OnboardingSegment = "loue" | "recherche" | "entree";

export type OnboardingMilestone = "profile" | "property";

export interface OnboardingState {
  gating: boolean;
  segment: OnboardingSegment | null;
  seen_guides: string[];
  dismissed_missions: string[];
  completed_missions: string[];
  collapsed_checklists: string[];
  reached_milestones: OnboardingMilestone[];
}

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  gating: false,
  segment: null,
  seen_guides: [],
  dismissed_missions: [],
  completed_missions: [],
  collapsed_checklists: [],
  reached_milestones: [],
};
